import { Draggable as DndDraggable } from "@hello-pangea/dnd";

export default function Draggable({ id, type, index, children, disabled }) {
	return (
		<DndDraggable draggableId={id} index={index} type={type} isDragDisabled={disabled}>
			{({ innerRef, draggableProps, dragHandleProps }) => (
				<div
					ref={innerRef}
					{...draggableProps}
					{...dragHandleProps}
					style={{
						paddingTop: "1em",
						...draggableProps.style,
					}}
				>
					{children}
				</div>
			)}
		</DndDraggable>
	);
}
